export default __webpack_public_path__ + "static/media/coin.a67c3656.png";